const style = {
  headerStyle: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    cursor: 'default',
    fontSize: 14,
    width: '100%',
  },
};

export default style;
